import React, { useEffect } from "react";
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

function DySelect({
  items,
  label,
  selectValue,
  setSelectValue,
  name,
  deActive,
  disabled,
  showRemove = true,
}) {
  const handleChange = (event) => {
    if (deActive) return;
    const field = event.target;
    setSelectValue((prev) => ({ ...prev, [field.name]: field.value }));
  };

  const handleClear = (e) => {
    e.stopPropagation();
    if (deActive) return;
    setSelectValue((prev) => ({ ...prev, [name]: "" }));
  };

  return (
    <FormControl
      sx={{
        width: "99%",
        margin: "0 4px",
        "& .MuiInputBase-formControl": { borderRadius: "4px" },
      }}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        labelId={`${name}-label`}
        id={`${name}-select`}
        value={selectValue?.[name] || ""}
        label={label}
        disabled={disabled}
        onChange={handleChange}
        name={name}
        displayEmpty
        sx={{
          "& .MuiSelect-outlined": { padding: "8px !important" },
        }}
        // make room for icon on the right
        endAdornment={
          showRemove && selectValue?.[name] ? (
            <InputAdornment position="start">
              <IconButton
                size="small"
                onClick={handleClear}
                edge="end"
                color="error"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      >
        {items?.map((item) => (
          <MenuItem key={item.key} value={item.value}>
            {item.key}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DySelect;
